<script setup>
// design 的「Related free tools」卡片（seo.js:27-29）。
// 数据来自 seo.cloud（同分类的兄弟工具），取前 4 个；统一用箭头图标、固定副标题 "Free tool"。
defineProps({
  tools: { type: Array, default: () => [] } // Array of [label, href]
})
</script>

<template>
  <section class="block tight">
    <div class="wrap">
      <div class="sec-h"><h2>Related free tools</h2></div>
      <div class="related">
        <NuxtLink
          v-for="(c, i) in tools.slice(0, 4)"
          :key="i"
          class="rel-card"
          :to="ftHref(c[1])"
        >
          <span class="rel-ico">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
          </span>
          <span>
            <span class="rn">{{ c[0] }}</span>
            <span class="rb">Free tool</span>
          </span>
        </NuxtLink>
      </div>
    </div>
  </section>
</template>
